var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgPhoto(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.237V24.93a3.073 3.073 0 01-.914 2.176 3.093 3.093 0 01-2.19.894H5.104a3.1 3.1 0 01-2.19-.894A3.083 3.083 0 012 24.93V12.237a3.077 3.077 0 01.92-2.166 3.097 3.097 0 012.184-.888h8.4v-3.29a1.896 1.896 0 011.2-1.757c.233-.093.484-.14.736-.136h8.024a1.914 1.914 0 011.768 1.167c.097.23.147.477.148.727v3.289h1.516a3.098 3.098 0 012.184.888c.582.573.913 1.351.92 2.166z",
    fill: "#CEE6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 5.894v3.289H13.524v-3.29a1.898 1.898 0 011.186-1.751c.231-.095.48-.143.73-.142h8.024a1.914 1.914 0 011.768 1.167c.097.23.147.477.148.727zM9.74 6.858h-3.6A1.178 1.178 0 004.968 8.03v1.153h5.944V8.03A1.17 1.17 0 009.74 6.858z",
    fill: "#737C80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.114H2v11.031h28v-11.03z",
    fill: "#899499"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.294c4.28 0 7.748-3.43 7.748-7.663 0-4.232-3.469-7.662-7.748-7.662-4.28 0-7.748 3.43-7.748 7.662 0 4.232 3.469 7.663 7.748 7.663z",
    fill: "#737C80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.36 18.628a6.332 6.332 0 01-1.764 4.336 6.377 6.377 0 01-8.716.455 6.336 6.336 0 01-2.208-4.13 6.305 6.305 0 011.842-5.118A6.347 6.347 0 0116 12.342c.447.001.894.048 1.332.14a6.347 6.347 0 013.102 1.64 6.314 6.314 0 011.75 3.036c.118.481.177.975.176 1.47zM22.46 5.567h-5.84a.743.743 0 00-.744.742v.965c0 .41.333.741.744.741h5.84c.41 0 .744-.332.744-.741v-.965a.743.743 0 00-.744-.742z",
    fill: "#E6FBFF"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 4)",
    d: "M0 0h28v24H0z"
  })))));
}
export default SvgPhoto;